import { normalizarData, normalizarValor } from '../../utils';

/**
 * Retorna TRUE se o array de dados (Sheet->JSON) se parecer com
 * um arquivo de Repasse da Sicredi.
 */
export const detectar = (dadosArray) => {
    // Procura pela assinatura clássica do Sicredi
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const linhaStr = linha.map(cell => String(cell).toLowerCase()).join(' ');
        if (linhaStr.includes('data do pagamento') && linhaStr.includes('valor pagamento')) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    for (let i = 0; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const linhaStr = linha.map(cell => String(cell).toLowerCase()).join(' ');
        if (linhaStr.includes('data do pagamento') && linhaStr.includes('valor pagamento')) {
            idxCabecalho = i;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho não encontrado. Falha arquitetural no parser Sicredi.');
    }

    const cabecalho = dadosArray[idxCabecalho];
    const idxData = cabecalho.findIndex(cell => String(cell).toLowerCase().includes('data do pagamento'));
    const idxValor = cabecalho.findIndex(cell => String(cell).toLowerCase().includes('valor pagamento'));
    const idxProduto = cabecalho.findIndex(cell => String(cell).toLowerCase() === 'produto' || String(cell).toLowerCase() === 'tipo');

    const repasses = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataIdxToUse = idxData !== -1 ? idxData : 0;
        const dataStr = String(linha[dataIdxToUse] || '').trim();
        const data = normalizarData(dataStr);

        let valor = null;
        if (typeof linha[idxValor] === 'number') {
            valor = linha[idxValor];
        } else {
            valor = normalizarValor(linha[idxValor]);
        }

        let tipoStr = 'Desconhecido';
        if (idxProduto !== -1 && linha[idxProduto]) {
            tipoStr = String(linha[idxProduto]).trim();
        }

        if (data && valor !== null && valor > 0) {
            repasses.push({
                linha: i + 1,
                data: data,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
